import { Item } from '../../types'
import { Option } from '../common/form/fields/dropdown/types'
import { Filters } from '../../hooks/useFilters/useFilters.type'
import { InventoryWarehouse } from '../common/crudItems/inventory/types'
import { SyntheticInputEvent } from 'react-number-format/types/types'

export type CheckoutModalProps = {
   isModalOpen: boolean
   handleClose: () => void
   checkoutAction: any
   selectedItems: Item[]
   handlePageCancelAndReset?: () => void
   viewTitle?: boolean
   isAdminCompanyUser?: boolean
   quantityInCart?: number
   handleWorkflowSuccess?: (response) => void
   selectedWarehouse?: InventoryWarehouse
   selectedTransferToWarehouse?: InventoryWarehouse
   isActionsPage?: boolean
   loggedInUserEmail?: string
   isTransferFromRequest?: boolean
}

export type CartOptions = {
   connection: string | null
   dueBackDate: string
   location: string | null
   selectedLocationId: string | null
   returnLocationId: string | null
   comment: string | null
}

export type BorrowViewProps = {
   handleDropdownChange: (value: string, option: Option) => void
   handleDateChange: (value: string, date: any) => void
   handleCommentChange: (value: string, comment: any) => void
   locationOptions: Option[]
   cartOptions: CartOptions
   enableLocationTracking: boolean
}

export type LoanAndFieldTransferViewProps = {
   validationErrors: Record<string, string>
   handleDropdownChange: (value: string, option: Option) => void
   connectionOptions: Option[]
   locationOptions: Option[]
   handleDateChange: (value: string, date: any) => void
   handleCommentChange: (value: string, comment: any) => void
   cartOptions: CartOptions
   enableLocationTracking: boolean
}

export type ReturnViewProps = {
   handleDropdownChange: (value: string, option: Option) => void
   handleCommentChange: (value: string, comment: SyntheticInputEvent) => void
   validationErrors: Record<string, string>
   warehouseOptions: WarehouseOption[]
   selectedReturnWarehouse: Option | null
   enableLocationTracking: boolean
}

export type SuccessViewProps = {
   itemCount: number
   view: string
   connectionName?: string
   dueBackDate?: string
   isAdminCompanyUser?: boolean
}

export type ErrorViewProps = {
   view: string
}

export type WarehouseTransferViewProps = {
   validationErrors: Record<string, string>
   handleCommentChange: (value: string, comment: any) => void
   handleDropdownChange: (value: string, option: Option) => void
   warehouseOptions: WarehouseOption[]
   selectedTransferToWarehouseOption: Option | null
}

export type ActionsFilterPanelProps = {
   isFilterPanelOpen: boolean
   handleClose: () => void
   applySavedFilters: (filterObject: Filters, toolStatusSuffix?: any) => void
   isPageFilterReset?: boolean
   setIsPageFilterReset?: (bool: boolean) => void
   isEmployeeUser?: boolean
   selectedActionQuickFilter: any
}

export type AddToCartButtonProps = {
   cell: any
   action: (id?: any) => void
   isHidden?: boolean
   isItemInCart: boolean
}

export type CartButtonProps = {
   onClick: () => void
   text: string
   iconId: string
   disabled?: boolean
}

export type ActionsQuantityModalProps = {
   isModalOpen: boolean
   handleClose: () => void
   handleAdjustTotal: (item: Item, val: string) => void
   handleCustomTotalChange: (e: any, item: Item) => void
   handleAddQuantityItemsToCart: (quantityItems: Item[]) => void
   getQuantityItemsFromPage: (array: Item[]) => Item[]
   items: Item[]
   isEdit?: boolean
   selectedActionQuickFilter?: any
}

// enums
export enum View {
   Loan = 'Loan',
   Return = 'Return',
   Field_Transfer = 'Field Transfer',
   Warehouse_Transfer = 'Warehouse Transfer',
   Borrow = 'Borrow',
   MakeAvailable = 'Make Available',
   MakeUnavailable = 'Make Unavailable',
}

// matches the backend requestType enum to display virtual connections or not
export enum ConnectionRequestType {
   LoanRequest = 1,
   TransferRequest = 2,
}
